import { render } from "./trendsItem.vue?vue&type=template&id=15a5bd0c&scoped=true"
import script from "./trendsItem.vue?vue&type=script&lang=js"
export * from "./trendsItem.vue?vue&type=script&lang=js"

import "./trendsItem.vue?vue&type=style&index=0&id=15a5bd0c&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a5bd0c"]])

export default __exports__